import { IDefineCommand } from 'core-ts-types';

angular
  .module('capability-ng-academic-planner')
  .service(
    'getEstimatedGraduationTimeCommand',
    function getEstimatedGraduationTimeCommand($http: ng.IHttpService, log: any, defineCommand: IDefineCommand) {
      return defineCommand(
        'getEstimatedGraduationTimeCommand',
        (deferred, termCommitment: string, termPreference: string) => {
          $http
            .get(`academicplan/graduation_term/`, {
              params: {
                time_commitment: termCommitment,
                term_preference: termPreference
              }
            })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              deferred.resolve(data.name);
            })
            .catch((e: string) => {
              log.issue(); // HACK empty issue to disable default error message popup
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/commands/get_estimated_graduation_time_command.ts